const styles = () => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flex: '0 0 auto',
    flexDirection: 'column',
    minHeight: 0,
    width: 66,
  },

  xBrandingRoot: {
    backgroundColor: '#3C434A',
  },

  legacyListItem: {
    position: 'relative',
    color: '#969BA1',
    fontSize: 20,
    height: 48,
    borderRadius: 6,
    padding: 0,
    width: 66,
  },

  legacyListItemLabel: {
    display: 'none',
  },

  legacyUnstyledLink: {
    position: 'relative',
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    borderRadius: 'inherit',
    transition: 'color ease .2s',

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 2,
      bottom: 2,
      left: 8,
      right: 8,
      borderRadius: 'inherit',
      transition: 'background-color ease .2s',
    },

    '& svg': {
      position: 'relative',
    },

    '&:hover': {
      color: 'rgba(255, 255, 255, .8)',

      '&::before': {
        backgroundColor: 'rgba(255, 255, 255, .05)',
      },
    },

    '&:focus': {
      color: 'rgba(255, 255, 255, .8)',

      '&::before': {
        backgroundColor: 'rgba(255, 255, 255, .05)',
      },
    },
  },

  legacyListItemTextSelected: {
    color: '#FFF',

    '& svg': {
      fill: 'url(#gradient-br-x)',
    },

    '& a::before': {
      backgroundColor: 'rgba(0, 0, 0, .2)',
    },

    '& a:hover::before': {
      backgroundColor: 'rgba(0, 0, 0, .2)',
    },

    '& a:focus::before': {
      backgroundColor: 'rgba(0, 0, 0, .25)',
    },
  },

  listItemSelected: {
    color: '#FFF',

    '& svg': {
      fill: 'url(#gradient-br-x)',
    },

    '& a::before': {
      backgroundColor: 'rgba(0, 0, 0, .2)',
    },

    '& a:hover::before': {
      backgroundColor: 'rgba(0, 0, 0, .2)',
    },

    '& a:focus::before': {
      backgroundColor: 'rgba(0, 0, 0, .25)',
    },
  },

  listItemLabel: {
    display: 'none',
  },

  spacer: {
    flex: '1 1 auto',
  },

  list: {
    flex: 'none',
  },

  companyIcon: {
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.2)',
    background: 'white',
  },

  lowerList: {
    paddingTop: 24,
    paddingBottom: 18,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },

  companyListItem: {
    '& a::before': {
      left: 4,
      right: 4,
    },
  },

  lowerListItemLink: {
    borderRadius: 5,
    color: '#969BA1',
    display: 'flex',
    fontSize: 18,
    height: 48,
    margin: '0 auto',

    '&:hover': {
      color: '#969BA1',
      backgroundColor: '#2b3237',
    },
  },

  lowerListItemLinkActive: {
    color: '#FFF !important',
  },

  paper: {
    left: '10px !important',
  },

  focusColor: {
    '&:focus': {
      color: '#27282A',
    },
  },
});

export default styles;
